import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';

interface MovieCardProps {
  movie: Movie;
  showType?: boolean;
}

export default function MovieCard({ movie, showType = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
      data-product-shop
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 神马影院影视资源`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50 dark:text-foreground-950">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type === 'movie' ? '电影' : '剧集'}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center gap-2 bg-gradient-to-t from-primary-950/95 to-transparent pb-3 pt-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex items-center gap-1 text-xs font-medium text-background-50">
            <i className="ri-play-circle-line text-base"></i> 查看详情
          </span>
        </div>
      </div>
      <div className="space-y-1.5 p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="flex items-center gap-2 text-xs text-foreground-400">
          <span>{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-background-400"></span>
          <span className="truncate">{movie.region}</span>
          {showType && (
            <>
              <span className="h-1 w-1 rounded-full bg-background-400"></span>
              <span>{movie.type === 'movie' ? '电影' : '电视剧'}</span>
            </>
          )}
        </p>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{movie.synopsis}</p>
      </div>
    </Link>
  );
}